import { Component, OnInit } from '@angular/core';
import { SquareEnvironment, SquareFilters, SquareLocation, SquareMoney, SquareTransfer, SquareService } from 'src/app/services/square.service';

@Component({
  selector: 'app-square-tests', templateUrl: './square-tests.component.html', styleUrls: ['./square-tests.component.scss']
})
export class SquareTestsComponent implements OnInit {
  environment: SquareEnvironment = 'sandbox';
  status: { configured: boolean; environment: string; apiVersion: string } | null = null;
  locations: SquareLocation[] = [];
  transfers: SquareTransfer[] = [];
  locationId = '';
  beginDate = this.localDate(new Date(Date.now() - 30 * 86400000));
  endDate = this.localDate(new Date());
  limit = 50;
  busy = false;
  connected = false;
  loaded = false;
  error = '';
  cursor: string | null = null;
  private activeFilters: SquareFilters | null = null;
  constructor(private square: SquareService) {}
  ngOnInit() {
    this.checkStatus();
  }
  changeEnvironment(environment: SquareEnvironment) {
    if (this.busy) return;
    this.environment = environment;
    this.status = null; this.locations = []; this.transfers = []; this.locationId = '';
    this.connected = false; this.loaded = false; this.error = ''; this.cursor = null; this.activeFilters = null;
    this.checkStatus();
  }
  private checkStatus() {
    this.busy = true;
    this.square.status(this.environment).subscribe({
      next: status => { this.status = status; this.busy = false; },
      error: error => this.fail(error)
    });
  }
  private localDate(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }
  connect() {
    if (this.busy) return;
    this.busy = true; this.error = ''; this.connected = false;
    this.square.locations(this.environment).subscribe({
      next: result => { this.locations = result.locations; this.connected = true; this.busy = false;
        if (!this.locationId && this.locations.length) this.locationId = this.locations[0].id; },
      error: error => this.fail(error)
    });
  }
  load(next = false) {
    if (this.busy) return;
    if (!next) {
      const begin = new Date(`${this.beginDate}T00:00:00`);
      const end = new Date(`${this.endDate}T00:00:00`);
      end.setDate(end.getDate() + 1);
      if (!this.beginDate || !this.endDate || !Number.isFinite(begin.getTime()) || !Number.isFinite(end.getTime()) || begin >= end) {
        this.error = 'Choose a valid start and end date.'; return;
      }
      this.activeFilters = { begin_time: begin.toISOString(), end_time: end.toISOString(), location_id: this.locationId || undefined, limit: this.limit };
      this.transfers = []; this.cursor = null; this.loaded = false;
    }
    if (!this.activeFilters || (next && !this.cursor)) return;
    this.busy = true; this.error = '';
    this.square.transfers(this.activeFilters, next ? this.cursor! : undefined, this.environment).subscribe({
      next: result => { this.transfers = [...this.transfers, ...result.transfers]; this.cursor = result.cursor; this.busy = false; this.loaded = true; },
      error: error => this.fail(error)
    });
  }
  money(value?: SquareMoney): string {
    if (!value) return '—';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: value.currency }).format(value.amount / 100);
  }
  fees(transfer: SquareTransfer): string {
    const fees = transfer.payout_fee.map(fee => fee.amount_money).filter((fee): fee is SquareMoney => !!fee);
    if (!fees.length) return '—';
    return this.money({ amount: fees.reduce((sum, fee) => sum + fee.amount, 0), currency: fees[0].currency });
  }
  private fail(error: any) { this.busy = false; this.error = error?.error?.error || 'Square request failed.'; }
}
